module.exports = __webpack_public_path__ + "img/circle-chevron-down.32689041.svg";